export default __webpack_public_path__ + "static/media/final.6a55a59a.jpg";